<h1 mat-dialog-title>Loading data...</h1>
<div mat-dialog-content>
	Please wait!
</div>
<!-- <div mat-dialog-actions>
	<div class="loading-spinner">
		<mat-progress-spinner diameter="40" strokeWidth="2"></mat-progress-spinner>
	</div>
</div> -->
